export const formatLocationText = (city?: string | null, state?: string | null): string => {
  const validValues = [city, state].filter((value) => value != null && value.trim() !== "");
  return validValues.join(", ");
};
